import type { NodeViewerComponent } from '.'
import { HorizontalRule } from '../../components'

export const HorizontalRuleNodeViewer: NodeViewerComponent = () => (
  <HorizontalRule />
)
